module.exports = __webpack_public_path__ + "img/mzb_qrcode.7316851c.jpg";